import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="recaptcha"
//
// 送信前にフォームへ2つの hidden field を足す。
//   human_proof     … サーバーが発行した署名付きの値。JS が動いた証拠になる
//   recaptcha_token … reCAPTCHA Enterprise のトークン
//
// トークンが取れなくても（スクリプトがブロックされている、通信が遅い、site key
// が未設定など）送信自体は必ず行い、判定はサーバー側に任せる。
// ここで送信を止めてしまうと、ユーザーからは「ボタンを押しても何も起きない」
// という直しようのない状態になるため。
export default class extends Controller {
  static values = {
    siteKey: String,
    action: String,
    proof: String,
    confirm: String,
    timeout: { type: Number, default: 5000 }
  }

  connect() {
    this.submitting = false
    this.#loadScript()
  }

  async submit(event) {
    // トークンを付けた後の再送信では何もしない
    if (this.submitting) return

    event.preventDefault()

    if (this.confirmValue && !window.confirm(this.confirmValue)) return

    if (this.hasProofValue) this.#appendHidden("human_proof", this.proofValue)

    const token = await this.#token()
    if (token) this.#appendHidden("recaptcha_token", token)

    this.submitting = true
    this.element.submit()
  }

  #loadScript() {
    if (!this.hasSiteKeyValue || !this.siteKeyValue) return

    const src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKeyValue}`
    if (document.querySelector(`script[src="${src}"]`)) return

    const script = document.createElement("script")
    script.src = src
    script.async = true
    script.defer = true
    document.head.appendChild(script)
  }

  // トークンが取れなければ null を返す（送信は止めない）
  #token() {
    if (!this.hasSiteKeyValue || !this.siteKeyValue) return Promise.resolve(null)

    return Promise.race([this.#execute(), this.#timeout()])
  }

  #execute() {
    return this.#waitForScript().then((grecaptcha) => {
      if (!grecaptcha) return null

      return new Promise((resolve) => {
        grecaptcha.enterprise.ready(() => {
          grecaptcha.enterprise
            .execute(this.siteKeyValue, { action: this.actionValue })
            .then(resolve)
            .catch((error) => {
              console.warn("reCAPTCHA execute failed:", error)
              resolve(null)
            })
        })
      })
    })
  }

  // 非同期読み込みなので、開いた直後に送信されると間に合っていないことがある
  #waitForScript() {
    return new Promise((resolve) => {
      const check = () => {
        if (typeof grecaptcha !== "undefined" && grecaptcha.enterprise) {
          resolve(grecaptcha)
        } else {
          setTimeout(check, 100)
        }
      }
      check()
    })
  }

  #timeout() {
    return new Promise((resolve) => setTimeout(() => resolve(null), this.timeoutValue))
  }

  #appendHidden(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    this.element.appendChild(input)
  }
}
